import { graphql, Link } from 'gatsby';

import { ComparisonTable } from '@mewa/ui';

export const ComparisonTableFragment = graphql`
  fragment ComparisonTableFragment on STRAPI__COMPONENT_COMPONENTS_COMPARISON_TABLE {
    title
    headingPro
    headingCon
    sections {
      sectionTitle
      pro
      con
    }
    headingCta
    labelCta
  }
`;

export type ComparisonTableData = {
  title: string;
  headingPro: string;
  headingCon: string;
  sections: {
    sectionTitle: string;
    pro: string;
    con: string;
  }[];
  headingCta: string;
  labelCta: string;
};

export const StrapiComparisonTable = ({
  data,
  className = '',
  cta: { onClick, url },
}: {
  data: ComparisonTableData;
  className?: string;
  cta: {
    onClick?: () => void;
    url: string;
  };
}) => (
  <ComparisonTable
    title={data.title}
    headingCon={data.headingCon}
    headingPro={data.headingPro}
    sections={data.sections.map((section) => ({
      title: section.sectionTitle,
      ...section,
    }))}
    className={className}
    cta={{
      component: Link,
      label: data.labelCta,
      props: {
        to: url,
      },
      onClick,
      heading: data.headingCta,
    }}
  />
);
